// extracted by mini-css-extract-plugin
export default {"breadcrumb":"Ti-z","breadcrumbItem":"Ui-z","hideOnMobile":"Vi-z"};